import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from 'core-tsi';

export const accesoLoginGuard: CanActivateFn = (_route, _state) => {

  const router = inject(Router)
  const session = StorageService.getSession()

  if (session) {
    router.navigate(['dashboard'])
    return false
  }

  return true
}
